import { useState, useEffect, useRef } from 'react';
import useAuth from './useAuth';
// API
import API from '../API';

import { API_URL,
  EMPLOYEES_BASE_URL
 } from '../config';

const initialState = {
  page: 0,
  player: '',
  total_pages: 0,
  total_results: 0
};
export const useEmployeeFetch = id => {
  const auth = useAuth();
  const [state, setState] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [trigger, setTrigger] = useState(false);
  const accessToken = auth.auth.accessToken
  console.log("binne use Employee fetch")
  console.log(id)
  useEffect(()=>{
    console.log("binne use Employee fetch se useEffect")
    const fetchEmployee = async()=>{
      try {
        setLoading(true);
        setError(false);
       setTrigger(false)
        const employee = await API.fetchEmployee(id,accessToken)
        const employeeData = employee?.employee?.[0] || initialState;

        // Fetch avatar if available
        let avatarUrl = '';
        console.log(`${EMPLOYEES_BASE_URL}${employeeData.avatar}`)
        if (employeeData.avatar) {
          try {
            const avatarResponse = await fetch(
              `${EMPLOYEES_BASE_URL}${employeeData.avatar}`,
              {
                headers: { Authorization: `Bearer ${accessToken}` },
              }
            );

            console.log(avatarResponse)
            if (avatarResponse.ok) {
              const blob = await avatarResponse.blob();
              avatarUrl = URL.createObjectURL(blob);
            }
          } catch (avatarError) {
            console.error('Error fetching avatar:', avatarError);
          }
        }
        console.log(employee)
        setState({  
          ...employeeData,avatarUrl
          
        }
        )

        setLoading(false)

      } catch (error) {
        console.log(error)
        setError(true);
      }
    }
    fetchEmployee()
  },[id,trigger]);

return{state,setState,loading,error,setLoading,setTrigger};


};